const content: {
  [key: string]: string | { [key: string]: string } | { [key: string]: string | { [key: string]: string } };
} = {
  title: {
    pageTitle: "Who's New Action Report",
    pageDescription:
      "This report shows a list of new ABOs, ABOs who have rejoined the business, and ABOs who have transitioned from customers in your group over the last 12 rolling months. Congratulations on your business growth!",
    pageTitleWithCustomers: "New ABO/PC Activity",
    pageDescriptionWithCustomers:
      "This report shows a list of new ABOs, ABOs who have rejoined the business, ABOs who have transitioned from customers, and all new customers in your group over the last 12 rolling months. Congratulations on your business growth!",
  },
  treeViewTabs: {
    thisMonth: "This Month",
    lastNumMonths: "Last {numberOfMonths} Months",
  },
  export: {
    button: "Export",
    title: "Export Report",
    descriptionMonths: "This report will include the last twelve months of who’s new",
    description: "This Report will include a list of who's new",
  },
  customerAboNumber: "Customer/ABO Number",
  exportConfirmation: "This report will include the last twelve months of who's new.",
  losTreeView: "LOS Tree View",
  table: {
    currentMonthTitle: "This Month",
    columns: {
      aboName: "ABO Name / Number",
      ppv: "PPV",
      annualPPV: "Annual PPV",
      gpv: "GPV",
      sponsoring: "Sponsoring",
      sponsoringYtd: "Annual Sponsoring",
      groupSize: "Group Size",
      customers: "Customers",
      autoRenewal: "Auto Renewal",
      watchlist: "Watchlist",
      bonus: "Bonus %",
      customerPv: "Customer PV",
      sponsorName: "Sponsor Name",
      pointsToNextLevel: "Points to Next Level",
      nonVcs: "Non VCS PV",
      gbv: "GBV",
    },
  },
  kpiSelectorDescription: "Select up to 8 KPIs to display in the report.",
  newCustomer: "New Customer",
} as const;

export default content;
